export interface PreloadedModule<T> {
  load: () => Promise<T>
  peek: () => T | null
}

// React.lazy always receives a thenable. Even when an earlier dynamic import
// already downloaded the module, a newly-created `.then(...)` can suspend the
// route for another React retry window. Keep the resolved value alongside the
// shared promise so a preloaded route can render synchronously.
export function createPreloadedModule<T>(loader: () => Promise<T>): PreloadedModule<T> {
  let promise: Promise<T> | null = null
  let value: T | null = null

  return {
    load() {
      if (promise) return promise
      promise = loader()
        .then((loaded) => {
          value = loaded
          return loaded
        })
        .catch((error: unknown) => {
          promise = null
          throw error
        })
      return promise
    },
    peek() {
      return value
    },
  }
}
